import { DEFAULT_PAGE_INDEX, MIN_LENGTH_DATE } from 'consts';
import { toJS } from 'mobx';
import { CalendarChangeParams } from 'primereact/calendar';
import { UserRoles } from '../enums';

export const removeUndefinedFromObj = (oldObj: { [key: string]: any }) => {
  const newObj = { ...oldObj };
  Object.keys(newObj).forEach((key) => {
    if (
      newObj[key] === undefined ||
      newObj[key] === null ||
      newObj[key] === 'null' ||
      newObj[key].length === 0
    ) {
      delete newObj[key];
    }
  });
  return newObj;
};

export const removeEmptyArraysFromObj = (oldObj: { [key: string]: any }) => {
  const newObj = { ...oldObj };
  Object.keys(newObj).forEach((key) => {
    if (Array.isArray(newObj[key]) && !toJS(newObj[key]).length) {
      delete newObj[key];
    }
  });
  return newObj;
};

export const getAccountRolesInRussian = (roles: string[]): string[] =>
  roles.map((role) => {
    if (role === 'USER') {
      return 'Пациент';
    }
    if (role === 'ADMIN') {
      return 'Администратор';
    }
    if (role === 'SUPPORT') {
      return 'Сотрудник тех. поддержки';
    }
    return 'Неподтвержденный аккаунт';
  });

export const getAccountRoleInRussian = (role: string): string => {
  if (role === UserRoles.USER) {
    return 'Пациент';
  }
  if (role === UserRoles.ADMIN) {
    return 'Администратор';
  }
  if (role === UserRoles.SUPPORT) {
    return 'Сотрудник тех. поддержки';
  }
  return 'Неподтвержденный аккаунт';
};

export const createLinkElementForBlob = (file: Blob, nameFile: string) => {
  const url = window.URL.createObjectURL(new Blob([file]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', `${nameFile}.xlsx`);
  document.body.appendChild(link);
  link.click();
  link.remove();
};

export const prepareDataForDateRangeFilter = (e: CalendarChangeParams) => {
  const dates = e.value as Date[];
  const hasDates = dates && dates.length > MIN_LENGTH_DATE;
  const dateFrom = hasDates ? dates[0]?.toISOString() : undefined;
  const dateTo = hasDates ? dates[1]?.toISOString() : undefined;
  const options = {
    dateFrom,
    dateTo,
    pageIndex: DEFAULT_PAGE_INDEX,
  };
  return { dates, dateFrom, dateTo, options };
};

export const formatUnixTimestamp = (timestamp: string | number): string => {
  if (!timestamp) return '-';

  const timestampNumber =
    typeof timestamp === 'string' ? parseFloat(timestamp) : timestamp;
  const date = new Date(timestampNumber * 1000);

  const day = date.getDate().toString().padStart(2, '0');
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const year = date.getFullYear();

  const hours = date.getHours().toString().padStart(2, '0');
  const minutes = date.getMinutes().toString().padStart(2, '0');

  return `${day}.${month}.${year} ${hours}:${minutes}`;
};

/**
 * Сравнивает две семантические версии в формате x.x.x
 * @param version1 - первая версия
 * @param version2 - вторая версия
 * @returns положительное число, если version1 > version2,
 *          отрицательное число, если version1 < version2,
 *          0, если версии равны
 */
export const compareVersions = (version1: string, version2: string): number => {
  const v1parts = version1.split('.').map(Number);
  const v2parts = version2.split('.').map(Number);

  for (let i = 0; i < Math.max(v1parts.length, v2parts.length); i += 1) {
    const v1part = v1parts[i] || 0;
    const v2part = v2parts[i] || 0;

    if (v1part > v2part) return 1;
    if (v1part < v2part) return -1;
  }

  return 0;
};
